<template>
    <div class="mak-performans-gostergesi d-flex justify-center mt-2">
        <div
            v-for="(item, ind) in performance"
            :key="ind + item.id + item.kontrol_zamani"
        >
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-on="on" v-bind="attrs" :color="item.color">
                        {{ item.icon }}
                    </v-icon>
                </template>
                <span>{{item.tooltip}}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'mak-performans-gostergesi',
        props: {
            kontroller: { type: Array },
            field: { type: String },
            controlCount: { type: Number },
        },
        computed: {
            performance() {
                let list = [];
                if (!this.kontroller.length) {
                     list = new Array(this.controlCount)
                        .fill(null)
                        .map(() => ({
                            color: 'red',
                            icon: 'mdi-calendar-remove',
                        }));
                }
                list = this.kontroller
                    .map(d => ({
                        ...d,
                        tooltip: moment(d.kontrol_zamani).format('DD MMMM YYYY HH:mm'),
                        color: d[this.field] === '1'
                            ? 'green'
                            : 'red',
                        icon: d[this.field] === '1'
                            ? 'mdi-calendar-check'
                            : 'mdi-calendar-remove',
                    }));
                return list.reverse();
            },
        },
    };
</script>

<style lang="scss">
    .mak-performans-gostergesi {
        .v-icon:hover {
            cursor: pointer;
            box-shadow:
                0 2px 1px -1px rgba(0,0,0,.2),
                0 1px 1px 0 rgba(0,0,0,.14),
                0 1px 3px 0 rgba(0,0,0,.12);
        }
    }
</style>
